var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73682 6.42857H7.04758V14.1429H5.73682V6.42857Z",
    fill: "#CC3633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66895 6.42857H10.9797V14.1429H9.66895V6.42857Z",
    fill: "#CC3633"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.493164 2.57143V3.85714H1.80393V16.7143C1.80393 17.0553 1.94203 17.3823 2.18785 17.6234C2.43366 17.8645 2.76706 18 3.1147 18H13.6008C13.9485 18 14.2819 17.8645 14.5277 17.6234C14.7735 17.3823 14.9116 17.0553 14.9116 16.7143V3.85714H16.2224V2.57143H0.493164ZM3.1147 16.7143V3.85714H13.6008V16.7143H3.1147Z",
    fill: "#CC3633"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73682 0H10.9799V1.28571H5.73682V0Z",
    fill: "#CC3633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.bc36acb53e1a08eae6e933aae682e7ad.svg";
export { ForwardRef as ReactComponent };